import React, { Component } from 'react'
import { Button, Text } from 'components/base'
import { centsToDollars, totalForUsersToDollars } from '../utils'
import Breadcrumb from './Breadcrumb'

import { CouponLabel, ReviewLine } from '../components'

export default class Review extends Component {
  componentDidMount() {
    this.section.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  render() {
    const total = totalForUsersToDollars(
      this.props.plan.amount,
      this.props.activeUsersCount
    )

    return (
      <div ref={section => (this.section = section)}>
        <Breadcrumb
          sections={['Review your order']}
          currentSectionIndex={0}
          indexOffset={4}
          onBack={this.props.onBack}
        />
        <Text.Subtitle>Plan details</Text.Subtitle>
        <ReviewLine label="Plan" className="capitalize">
          {this.props.plan.product}
        </ReviewLine>
        <ReviewLine
          label="Recurring billing"
          childrenClassName="flexbox flexbox-grow flexbox-space-between"
        >
          <div className="capitalize">{this.props.plan.interval}</div>
          <Text.PrimaryAction onClick={this.props.onSelectAlternativeInterval}>
            set to {this.props.plan.interval === 'year' ? 'monthly' : 'annual'}
          </Text.PrimaryAction>
        </ReviewLine>
        <ReviewLine label="Price per member">
          {centsToDollars(this.props.plan.amount)}/{this.props.plan.interval}
        </ReviewLine>
        <ReviewLine label="Members contributing">
          {this.props.activeUsersCount}
        </ReviewLine>
        <ReviewLine
          label="Total price"
          childrenClassName="flexbox flexbox-grow flexbox-space-between"
        >
          <div>{total}</div>
          {this.props.coupon && <CouponLabel coupon={this.props.coupon} />}
        </ReviewLine>
        <Text.Detail className="margin-vertical-large">
          Upon renewal, your cost will be {total} per {this.props.plan.interval}
          . We will automatically update your account balance when active
          members are added to or removed from your Slite team.
        </Text.Detail>

        <Text.Subtitle
          className="margin-vertical-medium"
          onEdit={this.props.onGoToCompanyEditSection}
        >
          Billing information
        </Text.Subtitle>
        <ReviewLine label="Company name">
          {this.props.companyDetails.companyName}
        </ReviewLine>
        <ReviewLine label="Billing email">
          {this.props.companyDetails.email}
        </ReviewLine>
        <ReviewLine label="VAT ID">
          {this.props.companyDetails.vatId}
        </ReviewLine>
        <ReviewLine label="Address" border={false}>
          <div>{this.props.companyDetails.address}</div>
          <div>{this.props.companyDetails.address2}</div>
          <div>
            {[
              this.props.companyDetails.zip,
              this.props.companyDetails.city,
              this.props.companyDetails.state,
            ]
              .filter(x => x)
              .join(', ')}
          </div>
          <div>{this.props.companyDetails.country}</div>
        </ReviewLine>

        <Text.Subtitle
          className="margin-vertical-large"
          onEdit={this.props.onGoToPaymentMethodSection}
        >
          Payment method
        </Text.Subtitle>
        <div className="flexbox flexbox-space-between shade-05 border-small border-shade-30 radius-large padding-vertical-medium padding-horizontal-medium">
          <div>Credit card</div>
          <div>**** **** **** {this.props.token.card.last4}</div>
          <div>{this.props.token.card.brand}</div>
          <div>
            Expire: {this.props.token.card.exp_month}/
            {this.props.token.card.exp_year}
          </div>
        </div>
        <div className="flexbox flexbox-align-center">
          <Button.Primary
            disabled={this.props.subscriptionOngoing}
            className="margin-vertical-larger"
            onClick={this.props.onConfirm}
          >
            {this.props.subscriptionOngoing
              ? 'Subscribing...'
              : 'Confirm your new subscription'}
          </Button.Primary>
          <Text.Action
            className="margin-horizontal-normal"
            onClick={this.props.onBack}
          >
            Previous step
          </Text.Action>
          {this.props.subscriptionError && (
            <div className="red">{this.props.subscriptionError.message}</div>
          )}
        </div>
      </div>
    )
  }
}
